<bn-loading-overlay></bn-loading-overlay>

<div class="container" [formGroup]="acompanhamentoForm" *ngIf="acompanhamentoForm && acompanhamento; else carregando">

    <div class="row">
        <div class="col">
            <h3>Posição da Carteira em Recuperação de Crédito <small class="text-muted">(#ID: {{acompanhamento.id}})</small></h3>
        </div>

        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltar()">Voltar</button>
        </div>
    </div>


    <div class="row">
        <div class="bn-form-group col-md-6">
            <label><b>Agente financeiro</b></label>
            <select name="cnpjAgenteFinanceiro" formControlName="cnpjAgenteFinanceiro" class="form-select">
                <option [value]=null>Todos</option>
                <option *ngFor="let agente of agentesFinanceiros" [value]="agente.cnpj">{{agente.nome}}</option>
            </select>
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Status do Protocolo</b></label>
            <input type="text" class="form-control" name="statusProtocolo" formControlName="statusProtocolo" />
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Data de Envio</b></label>
            <input type="text" class="form-control" name="dataEnvio" formControlName="dataEnvio" />
        </div>

    </div>

    <div class="row">
        <div class="bn-form-group col-md-3">
            <label><b>Id. Operação</b></label>
            <input type="text" class="form-control" name="idOperacao" formControlName="idOperacao" />
        </div>

        <div class="col-md-3">
            <label><b>Sistema: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
            </label>
            <select class="form-select" name="sistemaCobranca" formControlName="sistemaCobranca">
                <option value=null>Crédito Livre</option>
                <option value='15'>15 - Contratos FINAME</option>
                <option value='89'>89 - Contratos BNDES</option>
            </select>
        </div>

        <div class="col-md-3">
            <label><b>Id. externo operação: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
            </label>
            <input type="text" class="form-control" name="idExternoOperacao" formControlName="idExternoOperacao">
        </div>

        <div class="col-md-3">
            <label><b>Contrato: </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </label>
            <input type="text" class="form-control" name="contrato" formControlName="contrato">
        </div>
    </div>

    <div class="row">
        <div class="bn-form-group col-md-3">
            <label><b>Saldo Devedor Total</b></label>
            <input type="text" class="form-control" name="valorSaldoDevedorTotal" formControlName="valorSaldoDevedorTotal" bnMask="MOEDA" />
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Saldo Devedor de Principal</b></label>
            <input type="text" class="form-control" name="valorSaldoDevedorDePrincipal" formControlName="valorSaldoDevedorDePrincipal" bnMask="MOEDA" />
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Saldo de Juros na Normalidade</b></label>
            <input type="text" class="form-control" name="valorSaldoDeJurosNaNormalidade" formControlName="valorSaldoDeJurosNaNormalidade" bnMask="MOEDA" />
        </div>

        <div class="bn-form-group col-md-3">
            <label><b>Saldo de Encargos Moratórios</b></label>
            <input type="text" class="form-control" name="valorSaldoDeEncargosMoratorios" formControlName="valorSaldoDeEncargosMoratorios" bnMask="MOEDA" />
        </div>

    </div>

    <div class="row">
        <div class="bn-form-group col-md-2">
            <label><b>Cobrança Encerrada</b></label>
            <input type="checkbox" class="form-check checkbox-gigante" name="cobrancaEncerrada" formControlName="cobrancaEncerrada" />
        </div>

        <div class="bn-form-group col-md-5">
            <label><b>Tipo da Cobrança</b></label>
            <input type="text" class="form-control" name="tipoCobranca" formControlName="tipoCobranca" />
        </div>

        <div class="bn-form-group col-md-5">
            <label><b>Número do Processo</b></label>
            <input type="text" class="form-control" name="numeroProcesso" formControlName="numeroProcesso" />
        </div>

    </div>

    <div class="row">
        <div class="bn-form-group col-md-6">
            <label><b>Fase Processual</b></label>
            <input type="text" class="form-control" name="faseProcessual" formControlName="faseProcessual" />
        </div>

        <div class="bn-form-group col-md-6">
            <label><b>Espécie Ação / Recurso</b></label>
            <input type="text" class="form-control" name="especieAcaoRecurso" formControlName="especieAcaoRecurso" />
        </div>

    </div>
    <div class="row">
        <div class="bn-form-group col-md-12">
            <label><b>Juízo</b></label>
            <input type="text" class="form-control" name="juizo" formControlName="juizo" />
        </div>
        <div class="bn-form-group col-md-12">
            <label><b>Comarca</b></label>
            <input type="text" class="form-control" name="comarca" formControlName="comarca" />
        </div>
        <div class="bn-form-group col-md-12">
            <label><b>Observações</b></label>
            <textarea class="form-control" name="observacoes" formControlName="observacoes" rows="3"></textarea>
        </div>
    </div>

</div>

<div class="container row" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>